import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import SvgBattery from './SvgBattery';
import SvgHLine from './SvgHLine';
import "./Svg.css";
import SymbolAvgVoltage from './SymbolAvgVoltage';
import SymbolAvgPercent from './SymbolAvgPercent';
import BatteryAlarmDefs from './BatteryAlarmDefs';
import InverterAlarmDefs from './InverterAlarmDefs';
import Monitor from '../../../Monitor';

function SvgLeft({SN, x, y, width, height, master, Combinations, handleConverToMonitor, onNavigate}) {
    const { t } = useTranslation();

    let faults = [];


    const handleAlarmsShow = () => {
        let mdl = Modal.info({
            maskClosable: true,
            width: "800px",
            icon: null,
            title: (<div style={{display: "flex", justifyContent: "space-between"}}>
                <Button type="primary" danger>{t("Inverter/Battery Alarms")}</Button>
                <Button type="dashed" onClick={() => {mdl.destroy(); handleClick()}}>{t("Batteries Data")}</Button>
            </div>),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("From"), dataIndex: "From",  align: "left",render: (v,r) => {
                        return `[${v}] ${r.SN}`;
                    }},
                    { title: t("Name"), dataIndex: "Name",  align: "left", render: (v,r) => {
                        return `${v}${r.From=="Battery" ? "(L"+r.Level.toString()+")" : ""}`;
                    } },
                ]}
                dataSource={faults}
            />),
            onOk() {
            },
        });
    };

    const handleClick = () => {
        let mdl = Modal.info({
            maskClosable: true,
            width: "1000px",
            icon: null,
            title: (<div style={{display: "flex", justifyContent: "space-between"}}>
                <Button type="primary">{t("Batteries Data")}</Button>
                <Button type="dashed" danger onClick={() => {mdl.destroy(); handleAlarmsShow()}}>{t("Inverter/Battery Alarms")}</Button>
            </div>),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("Mounted Batteries"), dataIndex: "Batteries",  align: "left",render: (v,r) => {

                        return v&&(v.map((item,index) => {
                            return (<><Button onClick={()=>{
                                handleConverToMonitor(item.SN, item.SN);
                                onNavigate('Monitor', () => {
                                    return <Monitor />
                                }, "Inverter");
                                mdl.destroy();
                            }}>{item.SN}</Button><br/></>)
                        }));
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("SOC")+"(%)", dataIndex: "BatteryCapacity",  align: "right"},
                    { title: t("PBattery")+"(kW)", dataIndex: "PBattery",  align: "right", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.001).toFixed(3);
                    }},
                    { title: t("VBattery")+"(V)", dataIndex: "VBattery",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.01).toFixed(2):""} },
                ]}
                dataSource={Combinations}
            />),
            onOk() {
            },
        });
    };

    let SOC = 0;
    let Power = 0;
    let Voltage = 0;
    let count = Combinations?.length || 0;
    //
    let flowingToBattery = false;
    let flowingFromBattery = false;

    let batCount = 0; //电池个数
    
    if (Combinations != null) {
        let faults1 = []; //for inverter
        let faults2 = []; //for battery
        Combinations.forEach((item, index) => {
            (item.Batteries??[]).forEach((v) => {batCount += (v.SN?1:0)});

            let mode = item.InverterConnectionMode ?? 1;

            if (item.PBattery != null && item.PBattery > 0) {
                let v = parseInt(item.PBattery);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                Power += v;
            }
            if (item.BatteryCapacity != null) SOC += item.BatteryCapacity;
            if (item.VBattery != null) Voltage += item.VBattery;

            //
            if (item.ErrorCode1 != null) {
                let ec = window.BigInt(item.ErrorCode1);
                for (let i = 0; i < 4; i++) {
                    let e = (ec >> window.BigInt(i*16)) & 0xffffn;
                    if (e != 0 && [38,39,40].includes(Number(e))) {
                        faults1.push({
                            From: "Inverter",
                            SN: item.SN,
                            Code: Number(e),
                            Name: t(InverterAlarmDefs.AlarmsIndexToName[e.toString()]),
                            CreateTime: item.CreateTime
                        });
                    }
                }
            }
            if (item.ErrorCode2 != null) {
                let ec = window.BigInt(item.ErrorCode2);
                for (let i = 0; i < 4; i++) {
                    let e = (ec >> window.BigInt(i*16)) & 0xffffn;
                    if (e != 0 && [38,39,40].includes(Number(e))) {
                        faults1.push({
                            From: "Inverter",
                            SN: item.SN,
                            Code: Number(e),
                            Name: t(InverterAlarmDefs.AlarmsIndexToName[e.toString()]),
                            CreateTime: item.CreateTime
                        });
                    }
                }
            }
            //
            let ec = window.BigInt((item.BMSErrorCode1??0) + ((item.BMSErrorCode2??0) << 16));
            if (ec != 0) {
                for (let i = 0n; i < 32n; i++) {
                    let e = ( ec >> i) & 1n;
                    let name = InverterAlarmDefs.AlarmsIndexToName[(i+100n).toString()];
                    if (e != 0 && (name??"") != "") {
                        faults1.push({
                            From: "Inverter",
                            SN: item.SN,
                            Code: Number(i+100n),
                            Name: t(name),
                            CreateTime: item.CreateTime
                        });
                    }
                }
            }
            faults1.sort((a,b) => a.Code - b.Code);
            
            //
            if (item.Batteries != null) {
                item.Batteries.forEach((item2, index2) => {
                    if (item2.Alarms) {
                        for (let k in item2.Alarms) {
                            if (BatteryAlarmDefs.MapAlarmNameToName2[k] && item2.Alarms[k] != null && item2.Alarms[k] > 0) {
                                faults2.push({
                                    From: "Battery",
                                    SN: item2.SN,
                                    Code: BatteryAlarmDefs.MapAlarmNameToCategorys[k],
                                    Name: t(BatteryAlarmDefs.MapAlarmNameToName2[k]),
                                    Level: item2.Alarms[k],
                                    CreateTime: item2.Alarms.CreateTime
                                });
                            }
                        }
                    }
                });
            }
            faults2.sort((a,b) => a.Code - b.Code);
        });
        flowingFromBattery = Power < 0;
        flowingToBattery = Power > 0;
        Power = (Power * 0.001).toFixed(3);
        Voltage = (Voltage * 0.01).toFixed(2);

        
        faults = faults1.concat(faults2);
    }
    if (count > 0) {
        SOC = (SOC / count).toFixed(0);
        Voltage = (Voltage / count).toFixed(2);
    }


    let xx = width*3/5 - 84;
    let yy = height/2 - 84/2;

    return (<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" cursor={"pointer"}
        onClick={faults.length > 0 ? handleAlarmsShow : handleClick}
    >
        <SymbolAvgVoltage id="VoltageAvg-Left"/>
        <SymbolAvgPercent id="PercentAvg"/>

        <text x={10} y={30} fontSize="18" fill="black" fontWeight={500} textAnchor="start">{t("System Information")}</text>

        <text x={xx} y={yy+84 - 30*2} fontSize="20" fill="black" textAnchor="end">
            {Power} kW
            {count > 1 && <tspan dy="-1.2em" className='sigma'>(Σ{count})</tspan>}
        </text>
        <text x={xx-24} y={yy+84 - 30*1} fontSize="20" fill="black" textAnchor="end">{SOC} {count<=1?"%":""}</text>
        {count > 1 && <use href="#PercentAvg" x={xx-20} y={yy+84 - 30*1 - 20} fontSize="20" width="24" height="20" />}
        <text x={xx-24} y={yy+84 - 30*0} fontSize="20" fill="black" textAnchor="end">{Voltage} {count<=1?"V":""}</text>
        {count > 1 && <use href="#VoltageAvg-Left" x={xx-20} y={yy+84 - 30*0 - 20} fontSize="20" width="24" height="20" />}
        <SvgBattery SN={SN} x={xx} y={yy} width={84} height={84} SOC={SOC} color={faults.length>0?"red":"#1d80b5"}/>
        {Combinations?.length >= 1 && <svg x ={xx + 84 - 32} y={yy +84 - 32} width="32" height="32" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="46" stroke="#eee" strokeWidth="8" fill={faults.length>0?"red":"#1d80b5"} />
            <text x="50" y="53" fontSize="46px" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">{batCount ?? "?"}</text>
        </svg>}
        {/* 电池阈值 */}
        {(master||(Combinations&&Combinations.length>0))&&(<svg x={xx+17} y={yy + 84 + 6} fill='black'>
            <text y={0} fontSize={14} alignmentBaseline='hanging'>{t("Charge Limit")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{(((master??Combinations[0]).BatteryChargeCurrentLimit??0)*0.01).toFixed(2)}</tspan> A</text>
            <text y={20} fontSize={14} alignmentBaseline='hanging'>{t("Discharge Limit")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{(((master??Combinations[0]).BatteryDischargeCurrentLimit??0)*0.01).toFixed(2)}</tspan> A</text>
            <text y={40} fontSize={14} alignmentBaseline='hanging'>{t("Charge")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{((master??Combinations[0]).BMSChargeAndDischargeControl&(1<<7))!=0?t("Allowed"):t("Not Allowed")}</tspan></text>
            <text y={60} fontSize={14} alignmentBaseline='hanging'>{t("Discharge")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{((master??Combinations[0]).BMSChargeAndDischargeControl&(1<<6))!=0?t("Allowed"):t("Not Allowed")}</tspan></text>
            <text y={80} fontSize={14} alignmentBaseline='hanging'>{t("Force Charge")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{((master??Combinations[0]).BMSChargeAndDischargeControl&(3<<4))!=0?t("On"):t("Off")}</tspan></text>
            {/*<text y={100} fontSize={14} alignmentBaseline='hanging'>{t("Full-Charge")}: <tspan alignmentBaseline='hanging' fontWeight={"bold"}>{((master??Combinations[0]).BMSChargeAndDischargeControl&(1<<3))!=0?t("Allowed"):t("Not Allowed")}</tspan></text>*/}
        </svg>)}
        {/* ======= */}
        {flowingFromBattery && <SvgHLine id={SN+"BatteryAndInverters"} x={xx + 84} y={height / 2} x2={width} />}
        {flowingToBattery && <SvgHLine id={SN+"BatteryAndInverters"} x={width} y={height / 2} x2={xx + 84} />}
    </svg>);
}

export default SvgLeft;